
let styles = {
    container: {
      padding: '3%',
      display: 'flex',
      justifyContent: 'center',
    },
    table: {
        backgroundColor: '#dcdcdc',
        padding: '1%',
    },
    items: {
        padding: '1%',
    },
    
    item_header: {
        fontSize: '120%',
        fontWeight: 600,
        paddingLeft: '5%',
    },
    
    item_body: {
        padding: '6px ',
    },
    
    main_header: {
        padding: '1%',
        color: 'white',
        marginBottom: '3%',
        backgroundColor: 'rgb(122, 101, 149)',
    },

    input: {
        width: '50%',
        height: 25,
      },

    court_list: {
        padding: '1%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-around',
        borderBottom: '1px solid black',
    },
    button_submit: {
        padding: '1%',
        justifyContent: 'center',
        display: 'flex',
        paddingTop: '4%',
    },

    textbox: {
        width: '50%',
        height: 75,
      },

    message: {
        fontSize: '120%',
        fontWeight: 600,
        textAlign: 'center',
        color: 'red'
    }

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/bulkPause/style.js